import React from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../stores/useAuthStore";

const Impersonate = () => {
  const navigate = useNavigate();
  const { login } = useAuthStore();

  React.useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");
      const d = params.get("d");

      if (!token || !d) {
        navigate("/");
        return;
      }

      const user = JSON.parse(decodeURIComponent(atob(d)));
      login(user, token);
      navigate("/app/dashboard");
    } catch {
      navigate("/");
    }
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <p>Logging in, please wait...</p>
    </div>
  );
};

export default Impersonate;
